export default "__VITE_ASSET__Bdqcw8Bv__"